/**
 * Returns number of pixels `property` would mean in the context of `element`
 * @example pxInContext(main, "1em") //fontsize of `main`
 */
export function pxInContext(element: HTMLElement, property: string) {
  const div = document.createElement('div');
  div.style.setProperty('height', property);
  element.appendChild(div);
  const offsetHeight = Math.ceil(div.getBoundingClientRect().height);
  element.removeChild(div);
  return offsetHeight;
}
